import { Button } from "antd";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import InfoIcon from "../../../assets/icons/InfoIcon";
import { ModalComponentProps } from "../../../types";
import CustomModal from "../../ui/CustomModal";

type ExtendedProps = Omit<ModalComponentProps, "handleDraftMail"> & {
  handleDraftMail?: (val?: any) => void;
  handleDeleteMail?: () => void;
  setShowComposeModal?: any;
  loading?: boolean;
};

export default function DeleteConfirmationModal({
  handleClose,
  handleDraftMail,
  loading,
  setShowComposeModal,
  handleDeleteMail,
  ...rest
}: ExtendedProps) {
  return (
    <CustomModal
      title=""
      {...rest}
      handleClose={handleClose}
      width={400}
      footer={null}
    >
      <div className="flex justify-center">
        <div className="bg-[#FFF5F4] p-4 rounded-full text-xl text-[#FF3838] my-4">
          <InfoIcon />
        </div>
      </div>
      <div className="font-semibold text-lg text-[#2D3643] text-center">
        Do you want to delete this mail?
      </div>
      <div className="text-[#455468] text-sm text-center my-2">
        Are you sure you want to delete this mail? This action cannot be undone.
      </div>
      <div className="flex justify-between mt-4">
        <Button loading={loading} onClick={handleDraftMail}>
          Save in Draft
        </Button>
        <Button
          onClick={() => {
            setShowComposeModal(false);
            handleClose();
            handleDeleteMail && handleDeleteMail();
          }}
          className="flex items-center gap-2 text-[#FF3838] border-[#FFA19B] bg-[#FFF5F4]"
        >
          <span>
            <DeleteIcon />
          </span>
          <span>Yes, Delete</span>
        </Button>
      </div>
    </CustomModal>
  );
}
